module.exports = __webpack_public_path__ + "img/icon_home_pre.300a89de.png";